import { SMTTestID } from "@/constants/TestID";
import { Button, FAIconName } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

const baseTestID = SMTTestID.AddFoodType;

interface AddFoodTypeButtonBarProps {
  isNewFoodChecked: boolean;
  onFoodTypePress: (foodType: SMTFoodType) => void;
  onNewFoodPress: () => void;
  selectedFoodType?: SMTFoodType;
}

const AddFoodTypeButtonBar = ({
  isNewFoodChecked,
  onFoodTypePress,
  onNewFoodPress,
  selectedFoodType,
}: AddFoodTypeButtonBarProps) => {
  return (
    <HStack justifyContent="space-between">
      <Button
        isActive={selectedFoodType === "MEAL"}
        leftIcon={FAIconName.Salad}
        onPress={() => onFoodTypePress("MEAL")}
        testID={joinTestIDs(baseTestID, "MEAL")}
        title="Meal"
        variant="toggleable"
      />
      <Button
        isActive={selectedFoodType === "SNACK"}
        leftIcon={FAIconName.AlarmClock}
        onPress={() => onFoodTypePress("SNACK")}
        testID={joinTestIDs(baseTestID, "SNACK")}
        title="Snack"
        variant="toggleable"
      />
      <Button
        isActive={isNewFoodChecked}
        leftIcon={isNewFoodChecked ? FAIconName.CheckSquare : FAIconName.Square}
        onPress={onNewFoodPress}
        testID={joinTestIDs(baseTestID, "new-food")}
        title="New food"
        variant="toggleable"
      />
    </HStack>
  );
};

export default AddFoodTypeButtonBar;
export type { AddFoodTypeButtonBarProps };
